import { render, staticRenderFns } from "./coordinate-editor.vue?vue&type=template&id=3dc08d6c&"
import script from "./coordinate-editor.vue?vue&type=script&lang=js&"
export * from "./coordinate-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports